export default __webpack_public_path__ + "static/media/pwd_type_3_4_1.aaba513e.png";